import { Injectable } from '@angular/core';
import { GrantItem } from '../api/models';

@Injectable({
  providedIn: 'root',
})
export class GrantsService {
  grantList: string[] = [];

  constructor() {}
}
